import { render, staticRenderFns } from "./SimilarFeedRow.vue?vue&type=template&id=1717206a&scoped=true&"
import script from "./SimilarFeedRow.vue?vue&type=script&lang=js&"
export * from "./SimilarFeedRow.vue?vue&type=script&lang=js&"
import style0 from "./SimilarFeedRow.vue?vue&type=style&index=0&id=1717206a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1717206a",
  null
  
)

export default component.exports